export enum PriceContext {
  PRODUCT_INTRO,
  PRODUCT_COMBO_OPTION,
  PRODUCT_CARD,
  ADDON_UPSELL,
}

export enum CompareAtPriceDisplay {
  STRIKETHROUGH = "strikethrough",
  VALUE = "value",
}
